import { render, staticRenderFns } from "./workflowListSkeleton.vue?vue&type=template&id=38f1b288&scoped=true&"
import script from "./workflowListSkeleton.vue?vue&type=script&lang=js&"
export * from "./workflowListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./workflowListSkeleton.vue?vue&type=style&index=0&id=38f1b288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1b288",
  null
  
)

export default component.exports